// redux/slices/metalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const metalSlice = createSlice({
  name: "metal",
  initialState: {
    loading: false,
    data: {},
    error: null,
  },
  reducers: {
    getMetalsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getMetalsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      console.log("state.data",state.data)
    },
    getMetalsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getMetalsRequest,
  getMetalsSuccess,
  getMetalsFailure,
} = metalSlice.actions;

export default metalSlice.reducer;